<script setup>
import { onMounted, ref } from "vue";
import { useGlobalStore } from "@stores/global.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { prefersReducedMotion } from "@utils/prefersReducedMotion";

const props = defineProps(["title"]);

const global = useGlobalStore();
const section = ref(null);
const titleEl = ref(null);

onMounted(() => {
	if (prefersReducedMotion()) return;

	gsap.registerPlugin(ScrollTrigger);

	const scrollTrigger = ScrollTrigger.create({
		trigger: section.value,
		start: "top 80%",
		end: "bottom 20%",
		toggleActions: "play none none none",
	});

	gsap.from(titleEl.value, {
		y: 24,
		opacity: 0,
		duration: 0.8,
		delay: 0.2,
		ease: "power2.out",
		scrollTrigger: scrollTrigger,
	});
});
</script>

<template>
	<section class="pt-48 lg:pt-160 lg:pb-80" ref="section">
		<div class="container">
			<div class="relative">
				<h1 class="lg:h2 h4 font-primary" ref="titleEl">{{ title }}</h1>
				<div
					class="font-primary absolute -bottom-16 -left-90 hidden text-[200px] leading-[0.7] text-transparent uppercase opacity-10 lg:block"
					style="
						-webkit-text-stroke-width: 1px;
						-webkit-text-stroke-color: black;
					"
					aria-hidden="true"
				>
					{{ title }}
				</div>
			</div>
		</div>
	</section>
</template>
